import { Component } from '@angular/core';


@Component({
  selector: 'app-footer',
  templateUrl: '../Templates/footer.html',
})

/**
 * Implementation of footer component.
 */
export class FooterComponent {

  constructor() {}

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/footer.ts